export const SERVICE_LIMIT_MULTIPLIER = 50;
export const TIMER_INTERVAL = 5 * 1000;
export const SHORT_TIME_INTERVAL = 2 * 1000;
export const DEFAULT_MESSAGE_TTL = 5 * 60 * 1000;
